import { useNavigate, useParams } from "react-router-dom";
import ClientLayout from "../../components/Layout/ClientLayout";
import NoImage from "../../assets/images/No_Image_Available.jpg";
import Private from "../../assets/images/private.png";
import Kinangop3 from "../../assets/images/ololokwe.jpg";
import Kinangop4 from "../../assets/images/table_mountain.jpg";
import { GetTableListAPI } from "../../apiCaller/getAPIsCaller";
import {
  useGetAdventuresQuery,
  useGetDestinationsDetailQuery,
  useGetDestinationsImagesQuery,
} from "../../apiCaller/apis/getApi";
import HtmlContent from "../../utils/DisplayHTML";
import EventComponent from "../../components/eventCard/EventComponent";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { PiMountainsFill, PiPathBold } from "react-icons/pi";
import { FaSortAmountUpAlt, FaWalking } from "react-icons/fa";
import { FaChildren } from "react-icons/fa6";
import { MdAccessTimeFilled, MdLocationPin } from "react-icons/md";
import { GrMapLocation } from "react-icons/gr";
import { GiStrong } from "react-icons/gi";

import {
  APIProvider,
  Map,
  AdvancedMarker,
  Pin,
  InfoWindow,
} from "@vis.gl/react-google-maps";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Autoplay, Navigation, EffectCoverflow } from "swiper/modules";
import SpinningLoader from "../../components/SpinningLoader/SpinningLoader";
import Button, {
  BUTTON_TYPE_CLASSES,
} from "../../components/button/button.component";

const DestinatioDetail = () => {
  const [events, setEvents] = useState([]);
  const [search, setSearch] = useState({});
  const [coverImage, setCoverImage] = useState();
  const navigate = useNavigate()
  const [location, setLocation] = useState({
    lat: -0.9187714,
    lng: 36.4480015,
  });
  const { destinationId } = useParams();
  const {
    data: destination,
    error: destinationError,
    isLoading: destinationIsLoading,
    isFetching: destinationIsFetching,
  } = GetTableListAPI(
    { destinationId: destinationId },
    useGetDestinationsDetailQuery
  );

  const {
    data: destinationImages,
    error: destinationImagesError,
    isLoading: destinationImagesIsLoading,
    isFetching: destinationImagesIsFetching,
  } = GetTableListAPI(
    { destinationId: destinationId },
    useGetDestinationsImagesQuery
  );

  const {
    data: adventures,
    error: adventuresError,
    isLoading: adventuresIsLoading,
    isFetching: adventuresIsFetching,
  } = GetTableListAPI(search, useGetAdventuresQuery);

  useEffect(() => {
    if (adventures !== undefined && adventures?.results !== undefined) {
      setEvents(adventures?.results);
    }
  }, [adventures]);

  useEffect(() => {
    if (
      destination !== undefined &&
      destination?.Value?.latitude !== null &&
      destination?.Value?.longitude !== null
    ) {
      console.log(destination);
      setLocation({
        lat: +destination?.Value?.latitude,
        lng: +destination?.Value?.longitude,
      });
    }

    if (destination !== undefined) {
      const newSearch = { ...search, q: destination?.Value?.name };
      setSearch(newSearch);
    }
  }, [destination]);

  useEffect(() => {
    if (destinationImages !== undefined && destinationImages.length > 0) {
      setCoverImage(destinationImages.find((x) => x.isDisplayImage === true));
    }
  }, [destinationImages]);

  const handleClick = (image) => {
    console.log(image);
    setCoverImage(image);
  };

  const handleSendEmail = () => {
    const to = "info@mambahikers.com";
    const subject = encodeURIComponent("Hello from My App");
    const body = encodeURIComponent(
      "Hi there,\n\nI wanted to reach out to you..."
    );

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}`;

    window.open(gmailUrl, "_blank");
  };
  return (
    <ClientLayout>
      <div className="px-10 md:px-16 lg:px-24">
        {/* <h1 className="text-2xl font-semibold">
          Reijnders Musy Super Green Field
        </h1>

        <div className="flex items-center text-sm text-gray-500 mt-1 space-x-2">
          <span className="text-yellow-500">★ 4.7</span>
          <span>(253 reviews)</span>
          <span>·</span>
          <span>Jl. Impesak Cicurian, Cicuruy, Bandung, Cicuruy, Bandung</span>
        </div> */}

        <div className=" mt-4">
          {/* Main large image */}
          <div className="relative w-full h-[400px] lg:h-[500px]">
            {/* Overlay */}
            <div className="absolute inset-0 bg-color-primary-dark2 opacity-30 z-10"></div>

            {/* Background Image */}
            {destinationImagesIsFetching || destinationImagesIsLoading ? (
              <div className="h-full flex items-center justify-center">
                {" "}
                <SpinningLoader isLoading={true} hasData={false} />{" "}
              </div>
            ) : (
              <img
                src={coverImage?.image ? coverImage?.image : NoImage}
                alt="Main View"
                className="w-full h-full object-cover rounded-lg z-0"
              />
            )}

            {/* Title */}
            <div className="absolute left-1/2 top-[40%] transform -translate-x-1/2 -translate-y-1/2 z-20 text-center">
              <div className="text-5xl md:text-7xl text-white font-bold">
                {destination?.Value?.name}
              </div>
            </div>

            {/* Swiper Carousel */}
            <div className="absolute -bottom-16 left-1/2 transform -translate-x-1/2 w-[90%] md:w-[70%] lg:w-[50%] flex justify-center z-30">
              <div className="w-full">
                <Swiper
                  effect="coverflow"
                  slidesPerView={1}
                  breakpoints={{
                    300: { slidesPerView: 2 },
                    640: { slidesPerView: 2 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                  }}
                  spaceBetween={20}
                  coverflowEffect={{
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                  }}
                  loop={true}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: true,
                  }}
                  navigation={true}
                  modules={[EffectCoverflow, Autoplay, Navigation]}
                >
                  {destinationImages?.length > 0 ? (
                    destinationImages.map((destinationImage, index) => (
                      <SwiperSlide key={index}>
                        <div
                          className="cursor-pointer h-44 lg:h-64 w-60 lg:w-80"
                          onClick={() => handleClick(destinationImage)}
                        >
                          <img
                            src={destinationImage.image || NoImage}
                            alt="destination"
                            className="h-full w-full bg-cover rounded-lg shadow-md"
                          />
                        </div>
                      </SwiperSlide>
                    ))
                  ) : (
                    <SwiperSlide>
                      <div className="text-white text-center">
                        No images available
                      </div>
                    </SwiperSlide>
                  )}
                </Swiper>
              </div>
            </div>
          </div>

          {/* ))} */}

          {/* Overlay +12 */}
          {/* <div className="relative">
            <img
              src={Kinangop}
              alt="More images"
              className="w-full h-full object-cover rounded-lg"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
              <span className="text-white text-xl font-semibold">+12</span>
            </div>
          </div> */}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-10 lg:gap-32 my-24 lg:my-32 px-4 sm:px-6">
          {/* Left Section */}

          <div className="lg:col-span-3">
            {destinationIsLoading || destinationIsFetching ? (
              <div className="">
                <SpinningLoader isLoading={true} hasData={false} />
              </div>
            ) : (
              <div>
                <div className="text-4xl sm:text-5xl lg:text-6xl text-color-primary-dark1 font-semibold">
                  Learn more about {destination?.Value?.name}
                </div>

                <div className="my-6 sm:my-8">
                  <HtmlContent htmlData={destination?.Value?.description} />
                </div>

                {/* First row of stats */}
                <div className="flex flex-col sm:flex-row sm:flex-wrap sm:space-x-0 lg:space-x-5 gap-5 my-6 lg:my-10">
                  {/* Max Elevation */}
                  <div className="flex-1 border border-color-gray-dark rounded-lg">
                    <div className="flex space-x-3">
                      <div className="border-r border-color-primary-dark1 px-4 py-3">
                        <PiMountainsFill size={30} color="#040624" />
                      </div>
                      <div className="py-2">
                        <div className="text-color-primary-dark1 font-semibold">
                          Max Elevation
                        </div>
                        <div className="text-xl sm:text-2xl font-bold">
                          {destination?.Value?.maxElevation}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Elevation Gain */}
                  <div className="flex-1 border border-color-gray-dark rounded-lg">
                    <div className="flex space-x-3">
                      <div className="border-r border-color-primary-dark1 px-4 py-3">
                        <FaSortAmountUpAlt size={30} color="#040624" />
                      </div>
                      <div className="py-2">
                        <div className="text-color-primary-dark1 font-semibold">
                          Elevation Gain
                        </div>
                        <div className="text-xl sm:text-2xl font-bold">
                          {destination?.Value?.elevationGain}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Distance */}
                  <div className="flex-1 border border-color-gray-dark rounded-lg">
                    <div className="flex space-x-3">
                      <div className="border-r border-color-primary-dark1 px-4 py-3">
                        <FaWalking size={30} color="#040624" />
                      </div>
                      <div className="py-2">
                        <div className="text-color-primary-dark1 font-semibold">
                          Distance (KM)
                        </div>
                        <div className="text-xl sm:text-2xl font-bold">
                          {destination?.Value?.distanceInKm}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Second row of stats */}
                <div className="flex flex-col sm:flex-row sm:flex-wrap gap-5">
                  {/* Duration */}
                  <div className="flex-1 border border-color-gray-dark rounded-lg">
                    <div className="flex space-x-3">
                      <div className="border-r border-color-primary-dark1 px-4 py-3">
                        <MdAccessTimeFilled size={30} color="#040624" />
                      </div>
                      <div className="py-2">
                        <div className="text-color-primary-dark1 font-semibold">
                          Duration
                        </div>
                        <div className="text-xl sm:text-2xl font-bold">
                          {destination?.Value?.duration}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Country */}
                  <div className="flex-1 border border-color-gray-dark rounded-lg">
                    <div className="flex space-x-3">
                      <div className="border-r border-color-primary-dark1 px-4 py-3">
                        <GrMapLocation size={30} color="#040624" />
                      </div>
                      <div className="py-2">
                        <div className="text-color-primary-dark1 font-semibold">
                          Country
                        </div>
                        <div className="text-xl sm:text-2xl font-bold">
                          {destination?.Value?.country}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Location */}
                  <div className="flex-1 border border-color-gray-dark rounded-lg">
                    <div className="flex space-x-3">
                      <div className="border-r border-color-primary-dark1 px-4 py-3">
                        <MdLocationPin size={30} color="#040624" />
                      </div>
                      <div className="py-2">
                        <div className="text-color-primary-dark1 font-semibold">
                          Location
                        </div>
                        <div className="text-xl sm:text-2xl font-bold">
                          {destination?.Value?.location}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Third row of stats */}
                <div className="flex flex-col sm:flex-row sm:flex-wrap gap-5 my-6 lg:my-10">
                  {/* Difficulty */}
                  <div className="flex-1 border border-color-gray-dark rounded-lg">
                    <div className="flex space-x-3">
                      <div className="border-r border-color-primary-dark1 px-4 py-3">
                        <GiStrong size={30} color="#040624" />
                      </div>
                      <div className="py-2">
                        <div className="text-color-primary-dark1 font-semibold">
                          Difficulty
                        </div>
                        <div className="text-xl sm:text-2xl font-bold">
                          {destination?.Value?.difficulty}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Is Child Friendly */}
                  <div className="flex-1 border border-color-gray-dark rounded-lg">
                    <div className="flex space-x-3">
                      <div className="border-r border-color-primary-dark1 px-4 py-3">
                        <FaChildren size={30} color="#040624" />
                      </div>
                      <div className="py-2">
                        <div className="text-color-primary-dark1 font-semibold">
                          Is Child Friendly
                        </div>
                        <div className="text-xl sm:text-2xl font-bold">
                          {destination?.Value?.isChildFriendly ? "Yes" : "No"}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Is Traverse */}
                  <div className="flex-1 border border-color-gray-dark rounded-lg">
                    <div className="flex space-x-3">
                      <div className="border-r border-color-primary-dark1 px-4 py-3">
                        <PiPathBold size={30} color="#040624" />
                      </div>
                      <div className="py-2">
                        <div className="text-color-primary-dark1 font-semibold">
                          Is Traverse
                        </div>
                        <div className="text-xl sm:text-2xl font-bold">
                          {destination?.Value?.isTraverse
                            ? "Traverse"
                            : "Not Traverse"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Map Section */}
                {/* <div className="my-6 lg:my-10">
                <APIProvider apiKey="AIzaSyCkgjqMfIJDoofa7s7hYF2JdgSTo-kCZ9A">
                  <div className="h-[300px] sm:h-[400px]">
                    <Map zoom={10} center={location} mapId={"eedf04e74950ca44"}>
                      <AdvancedMarker position={location} />
                    </Map>
                  </div>
                </APIProvider>
              </div> */}
              </div>
            )}
          </div>

          {/* Right Section */}
          <div className="lg:col-span-1 mt-10 lg:mt-0">
            <div className="text-3xl sm:text-4xl lg:text-5xl text-color-primary-dark1 mb-6">
              Upcoming Events
            </div>
            {adventuresIsLoading || adventuresIsFetching ? (
              <div className="" >
                <SpinningLoader isLoading={true} hasData={false} />
              </div>
            ) : (
              <div>
                {events.length > 0 ? (
                  events.slice(0, 2).map((event, index) => (
                    <div key={index} className="my-5 pb-5 border-b-2" onClick={() => navigate(`/events/${event?.id}`)}>
                      <EventComponent adventure={event} imageHeigth={true} />
                    </div>
                  ))
                ) : (
                  <div className="font-semibold">
                    No upcoming events for {destination?.Value?.name}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* <div className="flex items-center justify-center h-[300px] bg-gray-50">
          <div className="px-24 text-center">
            <div>We Offer Private Hiking event</div>
            <div>
              Please contact us we organize for you or join a scheduled event to
              your desired destination
            </div>
            <div>Contact Us</div>
          </div>

        </div> */}

        <section className="relative min-h-[30vh]  lg:min-h-[35vh]  max-h-max bg-call-to-action2 bg-cover bg-bottom bg-fixed">
          <div className="absolute inset-0 bg-color-primary-dark1 opacity-30"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90vw] lg:w-[60vw] flex flex-col md:flex-row justify-between items-center text-white text-center p-12">
            <div className="">
              <div className="text-[2.5rem] font-bold">
                We offer private hiking events
              </div>
              <div>Please Contact us For more information</div>
            </div>
            <div>
              <Button buttonType={BUTTON_TYPE_CLASSES.inverted} onClick={handleSendEmail}>
                Contact Us
              </Button>
            </div>
          </div>
        </section>
      </div>
    </ClientLayout>
  );
};

export default DestinatioDetail;
